import { phone, phoneLink } from "../data";
import { motion } from "framer-motion";
import logo from '../imgs/logo.png'

export default function Header() {
  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="sticky-top bg-white shadow-sm"
      style={{ backgroundColor: 'var(--bg-light)' }}
    >
      <div className="container py-3">
        <div className="row align-items-center">
          <div className="col-6 col-md-4 d-flex align-items-center">
            <img src={logo} alt="Логотип" className="logo" />
            <h1 className="h3 mb-0 text-danger fw-bold">Помощь 24/7</h1>
          </div>
          <div className="col-6 col-md-8 d-flex justify-content-end gap-3">
            <a href={phoneLink} className="text-decoration-none text-dark fw-semibold fs-5 d-none d-md-block lh">
              {phone}
            </a>
            <a
              href={phoneLink}
              className="btn btn-danger rounded-pill px-4 py-2"
            >
              Вызвать мастера
            </a>
          </div>
        </div>
      </div>
    </motion.header>
  );
}